/**
 * Textes de l'écran « Plantages de l'app » : les plantages et blocages de
 * l'app iPhone et iPad, remontés par le système. Fichier à part, fusionné
 * dans le namespace `console`.
 */

export const frDiagnosticsIos = {
  diagnosticsIos: {
    titre: 'Plantages de l’app',
    texte:
      'Les plantages et blocages de l’app iPhone et iPad, regroupés par défaut. Aucune donnée de galerie ni de compte : version, appareil, système et pile d’appels. Conservés 90 jours.',
    chargement: 'Chargement des diagnostics…',
    erreurChargement: 'Impossible de lire les diagnostics.',
    vide: 'Aucun plantage ni blocage remonté.',
    filtres: { type: 'Afficher', tous: 'Tout', plantage: 'Plantages', blocage: 'Blocages' },
    type: { plantage: 'Plantage', blocage: 'Blocage' },
    colonnes: {
      defaut: 'Défaut',
      version: 'Version',
      occurrences: 'Occurrences',
      appareils: 'Appareils',
      dernier: 'Dernière fois',
    },
    version: '{{version}} ({{build}})',
    testflight: 'TestFlight',
    signal: 'Signal {{signal}}',
    duree: '{{secondes}} s sans réponse',
    sansPile: 'Pile absente',
    detail: 'Voir la pile',
    masquer: 'Masquer la pile',
    detailChargement: 'Chargement de la pile…',
    detailErreur: 'Impossible de lire la pile.',
    filAttribue: 'Fil en cause',
    fil: 'Fil {{rang}}',
    contexte: '{{appareil}} · {{systeme}} · {{architecture}}',
    raisonFin: 'Raison : {{raison}}',
    exception: 'Exception : {{nom}}',
  },
};

export const enDiagnosticsIos: typeof frDiagnosticsIos = {
  diagnosticsIos: {
    titre: 'App crashes',
    texte:
      'Crashes and hangs of the iPhone and iPad app, grouped by defect. No gallery or account data: version, device, system and call stack. Kept for 90 days.',
    chargement: 'Loading diagnostics…',
    erreurChargement: 'Could not read the diagnostics.',
    vide: 'No crash or hang reported.',
    filtres: { type: 'Show', tous: 'All', plantage: 'Crashes', blocage: 'Hangs' },
    type: { plantage: 'Crash', blocage: 'Hang' },
    colonnes: {
      defaut: 'Defect',
      version: 'Version',
      occurrences: 'Occurrences',
      appareils: 'Devices',
      dernier: 'Last seen',
    },
    version: '{{version}} ({{build}})',
    testflight: 'TestFlight',
    signal: 'Signal {{signal}}',
    duree: 'Unresponsive for {{secondes}} s',
    sansPile: 'No stack',
    detail: 'Show stack',
    masquer: 'Hide stack',
    detailChargement: 'Loading stack…',
    detailErreur: 'Could not read the stack.',
    filAttribue: 'Faulting thread',
    fil: 'Thread {{rang}}',
    contexte: '{{appareil}} · {{systeme}} · {{architecture}}',
    raisonFin: 'Reason: {{raison}}',
    exception: 'Exception: {{nom}}',
  },
};
